import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SCAN_TEXT: GlameraIconDefinition = {
  name: 'scan-text',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-scan-text-frame" d="M3 7V5a2 2 0 0 1 2-2h2"></path>
    <path class="glm-scan-text-frame" d="M17 3h2a2 2 0 0 1 2 2v2"></path>
    <path class="glm-scan-text-frame" d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
    <path class="glm-scan-text-frame" d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
    <path class="glm-scan-text-line glm-scan-text-line-0" d="M7 8h8"></path>
    <path class="glm-scan-text-line glm-scan-text-line-1" d="M7 12h10"></path>
    <path class="glm-scan-text-line glm-scan-text-line-2" d="M7 16h6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-scan-text-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './scan-text.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ScanTextIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SCAN_TEXT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
